import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'app-ext-v5',
  templateUrl: './ext-v5.component.html',
  styleUrls: ['./ext-v5.component.css']
})
export class ExtV5Component implements OnInit {
    @Input('paramFormExtV5') paramFormExtV5: FormGroup;
    @Input('readOnly') readOnly: boolean;
  constructor() { }

  ngOnInit() {
  }

}
